export default __webpack_public_path__ + "static/posterElliottSmith-1ac5768c7d2e61ff451daef34d42a8e5.svg";